import React from 'react';
import { useState, useEffect } from 'react';
import './Data.css';

function Data() {
  const [data, setData] = useState([])

  useEffect(() => {
    setInterval(() => {
      fetch("https://randomuser.me/api/")
      .then((res) => res.json())
      .then((data) => {
        setData(data.results);
      })
    }, 5000);
  }, [])


  return (
    <>
      {
        data.map((row, index) => {
          return (
            <div key={index}>
              <div className="wrap-1">
                <div className="container">
                  <div className="row">
                    <div className="col-12">
                      <div className='imgBack'>
                        <img src={row.picture.large} alt="picture" className='img' />
                        <p><span>{row.name.title}&nbsp;{row.name.first}&nbsp;{data[0].name.last}</span> | {row.gender}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="wrap-2">
                <div className="container">
                  <div className="row">
                    <div className="col-4 col-m-6">
                      <div className="info">

                        <div className='country infoBox'>
                          <p><b>Country</b></p>
                          <p>{row.location.country}</p>
                        </div>
                        <div className="email infoBox">
                          <p><b>Email</b></p>
                          <p>{row.email}</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-4 col-m-6">
                      <div className='info'>
                        <div className="phone infoBox">
                          <p><b>Phone</b></p>
                          <p>{row.phone}</p>
                        </div>
                        <div className="age infoBox">
                          <p><b>Age</b></p>
                          <p>{row.dob.age}</p>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        })
      }
    </>
  )
}

export default Data;